<div class="card">
    <div class="card-body">
        <h5 class="card-title main-blue">{{ title | translate }}</h5>
        <div class="card-text">
            @for (week of weeks; track week) {
                <div class="voffset-20">
                    <div class="main-blue">{{ week.title }}</div>
                    @for (item of week.sessions; track item) {
                        <div>
                            <app-acquired-session-item
                                [item]="item"
                            ></app-acquired-session-item>
                        </div>
                    }
                </div>
            }

            @if (!allTheSessionsRefunded) {
                <app-acquired-sessions-summary
                    [purchase]="purchase"
                ></app-acquired-sessions-summary>
            }
            @if (allTheSessionsRefunded) {
                <div>
                    {{ "PurchaseDetails.allSessionsRemoved" | translate }}
                </div>
            }
        </div>
    </div>
</div>
